import { Divider, Grid, Typography } from "@mui/material";
import React from "react";
import WSSelectField from "../../../../Components/Select/WSSelect";
import config from "../../../../Config/clientConfig.json";
import { useFormContext } from "react-hook-form";
import WSTextField, { TextType } from "../../../../Components/TextBox/WSTextBox";
import WSSCheckBoxField from "../../../../Components/CheckBox/WSCheckBox";
import WSRadioField from "../../../../Components/Radio/WSRadio";

export const VoucherPrintSettings: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
    <>
      <Typography>Voucher Print Settings</Typography>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} >
        <Typography>Voucher Type</Typography>

        </Grid>
       
        <Grid item xs={12} sm={6}>
        <Typography>Indent</Typography>

        </Grid>
        <Grid item xs={12} sm={6}>
        <WSRadioField
              id="indent"
              name="indent"
              label=""
              control={control}
              defaultValue={"current"}
              options={config.voucherConfig.staticOptionData}
              rules={{ required: true }}
            />
        </Grid>
        
        <Grid item xs={12} sm={6}>
        <Typography>Issue</Typography>

        </Grid>
        <Grid item xs={12} sm={6}>
        <WSRadioField
              id="issue"
              name="issue"
              label=""
              control={control}
              defaultValue={"current"}
              options={config.voucherConfig.staticOptionData}
              rules={{ required: true }}
            />
        </Grid>
        
        <Grid item xs={12} sm={6}>
        <Typography>Purchase Order</Typography>

        </Grid>
        <Grid item xs={12} sm={6}>
        <WSRadioField
              id="po"
              name="po"
              label=""
              control={control}
              defaultValue={"current"}
              options={config.voucherConfig.staticOptionData}
              rules={{ required: true }}
            />
        </Grid>
        <Grid item xs={12} sm={6}>
        <Typography>Purchase </Typography>

        </Grid>
        <Grid item xs={12} sm={6}>
        <WSRadioField
              id="purchase"
              name="purchase"
              label=""
              control={control}
              defaultValue={"current"}
              options={config.voucherConfig.staticOptionData}
              rules={{ required: true }}
            />
        </Grid>
        <Grid item xs={12} sm={6}>
        <Typography>Goods Return</Typography>

        </Grid>
        <Grid item xs={12} sm={6}>
        <WSRadioField
              id="goodsreturn"
              name="goodsreturn"
              label=""
              control={control}
              defaultValue={"current"}
              options={config.voucherConfig.staticOptionData}
              rules={{ required: true }}
            />
        </Grid>
        
      </Grid>
    </>
  );
});
